import { createSlice } from '@reduxjs/toolkit';
import { saveLog, getVaults, deleteLog } from './vaultsActions';

const initialState = {
  loading: false,
  vaults: [],
  error: null,
  success: false,
};

const vaultsSlice = createSlice({
  name: 'vaults',
  initialState,
  reducers: {},
  extraReducers: {
    // get vaults
    [getVaults.pending]: state => {
      state.loading = true;
    },
    [getVaults.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.vaults = payload.data.sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
    },
    [getVaults.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // save log
    [saveLog.pending]: state => {
      // state.loading = true;
    },
    [saveLog.fulfilled]: (state, { payload }) => {
      state.loading = false;
      // state.docs = payload.data;
    },
    [saveLog.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // delete log
    [deleteLog.pending]: state => {
      // state.loading = true;
    },
    [deleteLog.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [deleteLog.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default vaultsSlice.reducer;
